import { ACCOUNT_CATEGORY } from "../../actions/type";

export default function accountByCategory(state = [], action) {
    switch (action.type) {
        case ACCOUNT_CATEGORY:
            return action.payload;
        default:
            return state
    }
}